var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Steps',[_c('SwapableStep',[_c('Title',{attrs:{"index":4}},[_vm._v(_vm._s(_vm.$t('process.step_4_title')))]),_c('StepText',[_vm._v(_vm._s(_vm.$t('process.step_4_text_1'))+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }